import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Asegúrate de importar useNavigate
import { auth, db } from '../utils/firebaseConfig';
import { signInWithEmailAndPassword, createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import GeneralNavbar from './GeneralNavbar'; // Importa el GeneralNavbar
import './UserForm.css'; // Importa el archivo de estilos CSS para el formulario

function UserForm() {
  const [name, setName] = useState(''); // Cambiado a "name"
  const [apellido, setApellido] = useState(''); // Cambiado a "apellido"
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [telefono, setTelefono] = useState(''); // Nuevo campo para el teléfono
  const [role, setRole] = useState('employee'); // Valor por defecto ahora es "employee"
  const [error, setError] = useState('');

  // Hook de navegación
  const navigate = useNavigate(); // Este hook se usa para redirigir

  // Función para manejar el retroceso
  const handleBackClick = () => {
    navigate('/admin'); // Redirige al componente Admin (ajusta la ruta según sea necesario)
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setError('');

  const currentUser = auth.currentUser;
  const currentEmail = currentUser.email;
  const currentPassword = prompt('Por seguridad, reingrese su contraseña para continuar');

  if (!currentPassword) {
    setError('Debe ingresar la contraseña para continuar.');
    return;
  }

  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    await setDoc(doc(db, 'users', user.uid), {
      uid: user.uid,
      name,
      apellido,
      email,
      role,
      telefono: telefono || null
    });

    // ✅ Reautenticar al admin
    await signInWithEmailAndPassword(auth, currentEmail, currentPassword);
    alert('Usuario creado correctamente.');
    navigate('/admin');

  } catch (err) {
    setError('Error al crear el usuario: ' + err.message);
    console.error('Error al crear el usuario:', err);
  }
};


  return (
    <div>
      <GeneralNavbar title="Crear Usuario" onBackClick={handleBackClick}/>
      <div className="user-form-container">
        {error && <p className="error-message">{error}</p>}
        <form onSubmit={handleSubmit} className="user-form">
          <div className="form-group">
            <label htmlFor="name">Nombre:</label>
            <input
              type="text"
              id="name"
              value={name} // Ahora el valor se asigna a "name"
              onChange={(e) => setName(e.target.value)} // Actualiza "name"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="apellido">Apellido:</label>
            <input
              type="text"
              id="apellido"
              value={apellido} // Ahora el valor se asigna a "apellido"
              onChange={(e) => setApellido(e.target.value)} // Actualiza "apellido"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email:</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Contraseña:</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="telefono">Teléfono (opcional):</label>
            <input
              type="text"
              id="telefono"
              value={telefono} // Valor para el teléfono
              onChange={(e) => setTelefono(e.target.value)} // Actualiza "telefono"
              placeholder="Ingrese el teléfono (opcional)"
            />
          </div>
          <div className="form-group">
            <label htmlFor="role">Rol:</label>
            <select
              id="role"
              value={role}
              onChange={(e) => setRole(e.target.value)}
              required
            >
              <option value="admin">Administrador</option>
              <option value="employee">Empleado</option>
            </select>
          </div>
          <button type="submit" className="submit-button">Crear Usuario</button>
        </form>
      </div>
    </div>
  );
}

export default UserForm;

